import Cookies from 'js-cookie'

export default function () {
  const key = 'cookie-support'
  const value = 'test'
  Cookies.set(key, value)
  const testCookie = Cookies.get(key)

  if (testCookie !== value) {
    return false
  }

  Cookies.remove(key)

  return true
}
